import { Header } from "@/app/layout/Header";
import { QueryState } from "@/shared/ui/QueryState";
import { useNavigate, useParams } from "@tanstack/react-router";
import { useMyQcRecordDetailQuery } from "../api/queries";
import { QcRecordDetailView } from "../ui/QcRecordDetailView";

export function QcRecordDetailPage() {
  const { recordId } = useParams({
    from: "/app/qc/inspection/record/$recordId",
  });
  const navigate = useNavigate();
  const query = useMyQcRecordDetailQuery(recordId, {
    enabled: Boolean(recordId),
  });

  if (query.isLoading) {
    return <QueryState isLoading>ກຳລັງໂຫຼດ...</QueryState>;
  }

  if (query.isError || !query.data) {
    return (
      <QueryState isError error={query.error}>
        ບໍ່ພົບບັນທຶກ ຫຼື ເກີດຂໍ້ຜິດພາດ
      </QueryState>
    );
  }

  const { record, items } = query.data;

  return (
    <>
      <Header />
      <QcRecordDetailView
        record={record}
        items={items}
        title="ລາຍລະອຽດບັນທຶກການກວດ QC"
        onBack={() =>
          navigate({ to: "/app/qc/inspection", search: { page: 1 } })
        }
      />
    </>
  );
}
